import styles from '../styles.module.scss';
import {Messages} from 'services/lang/messages';
import classNames from 'classnames';
import {system} from 'services/objects';
import {getDisplayName} from 'utilsOld/getDisplayName';

/**
 * @typedef {Object} FormInputProps
 * @property {function} onChange
 * @property {string} errorText
 * @property {function} validate
 * @property {string} value
 * @property {function} handleBlur
 * @property {boolean} isTouched
 * @property {boolean} hasError
 * @returns {JSX.Element}
 */

const {
  INPUT_PLACEHOLDERS: {PASSWORD, LOGIN: LOGIN_PLACEHOLDER, EMAIL, NAME},
} = system;

const withError =
  (BaseComponent, key = '') =>
  props => {
    BaseComponent.displayName = `withError(${getDisplayName(BaseComponent)})`;
    const hasError = props.isTouched && props.errorText;
    return (
      <div className={styles.errorWrapper} key={key}>
        <BaseComponent hasError={hasError} {...props} />
        {hasError && (
          <div className={'error-text'}>
            <i className={classNames('fas fa-exclamation-circle', styles.errorIcon)} />
            {props.errorText}
          </div>
        )}
      </div>
    );
  };

const ID = system.LOGIN_PAGE_CONSTANTS.ID;
export const NameField = withError(({validate, hasError, onChange, value, handleBlur}) => {
  return (
    <input
      type='text'
      id={ID.NAME_FIELD}
      onChange={e => {
        onChange(e.target.value);
        validate(e.target.value);
      }}
      value={value}
      onBlur={handleBlur(NAME)}
      placeholder={Messages.Controls.Name}
      className={classNames({
        [styles.inputLoginPage]: true,
        [styles.inputLoginPageError]: hasError,
      })}
    />
  );
}, ID.NAME_FIELD);

/**
 * @param {FormInputProps} props
 * @returns {JSX.Element}
 */
export const LoginField = withError(({validate, hasError, onChange, value, handleBlur}) => {
  return (
    <input
      type='text'
      id={ID.LOGIN_FIELD}
      placeholder={Messages.Controls.Login}
      onChange={e => {
        onChange(e.target.value);
        validate(e.target.value);
      }}
      value={value}
      onBlur={handleBlur(LOGIN_PLACEHOLDER)}
      className={classNames({
        [styles.inputLoginPage]: true,
        [styles.inputLoginPageError]: hasError,
      })}
    />
  );
}, ID.LOGIN_FIELD);

export const EmailField = withError(({validate, hasError, onChange, value, handleBlur}) => {
  return (
    <input
      type='text'
      id={ID.EMAIL_FIELD}
      placeholder={Messages.Controls.Email}
      onChange={e => {
        onChange(e.target.value);
        validate(e.target.value);
      }}
      onBlur={handleBlur(EMAIL)}
      value={value}
      className={classNames({
        [styles.inputLoginPage]: true,
        [styles.inputLoginPageError]: hasError,
      })}
    />
  );
}, ID.EMAIL_FIELD);

/**
 * @param {FormInputProps} props
 * @returns {JSX.Element}
 */
export const PasswordField = withError(({onChange, validate, value, handleBlur, hasError}) => {
  return (
    <input
      type='password'
      id={ID.PASSWORD_FIELD}
      placeholder={Messages.Controls.Password}
      onChange={e => {
        onChange(e.target.value);
        validate(e.target.value);
      }}
      onBlur={handleBlur(PASSWORD)}
      value={value}
      autoComplete='on'
      className={classNames({
        [styles.inputLoginPage]: true,
        [styles.inputLoginPageError]: hasError,
      })}
    />
  );
}, ID.PASSWORD_FIELD);

export const ConfirmField = ({confirmationValue, setConfirmationValue}) => {
  return (
    <input
      type='password'
      id={ID.CONFIRM_FIELD}
      key={ID.CONFIRM_FIELD}
      placeholder={Messages.Controls.Confirmation}
      onChange={e => setConfirmationValue(e.target.value)}
      value={confirmationValue}
      autoComplete='on'
      className={styles.inputLoginPage}
    />
  );
};
